<script>
	import { onMount } from 'svelte';
	import Identity from 'svelte-key';
	import { fetchData, generateID, isTouchEnabled } from '../components/shared/utils/Data.svelte';
	import { projectSort } from '../components/shared/utils/Sort.svelte';
	import { fly } from 'svelte/transition';
	import LoginModal from '../components/shared/modal/Login.svelte';
	import MediaViewModal from '../components/shared/modal/MediaView.svelte';
	import MediaUploadModal from '../components/shared/modal/MediaUpload.svelte';
	import ForbiddenModal from '../components/shared/modal/Forbidden.svelte';
	import Form from '../components/form/Form.svelte';
	import InfoModal from '../components/shared/modal/Info.svelte';
	import ConfirmationModal from '../components/shared/modal/Confirmation.svelte';
	import FormModal from '../components/shared/modal/Form.svelte';

	export let messageToken;
	
	let tooltips = true;
	let toast = null;
	let polling = false;
	let submit = false;
	let keys = {
		form: "1",
		content: "1",
		toast: "1"
	}
	let form = "";
	let formId = "";
	let content = {
        id: "",
        view: ""
    };
	let modal = {
		view: ""
	};
	let session = {
        workspaces: []
	};
	let contentViews = {
		form: Form
	}
	let modalViews = {
		login: LoginModal,
		mediaView: MediaViewModal,
		mediaUpload: MediaUploadModal,
		forbidden: ForbiddenModal,
		info: InfoModal,
		confirmation: ConfirmationModal,
		form: FormModal
	}
	let isPublic = false;
	if (localStorage.getItem("session")) {
		session = JSON.parse(localStorage.getItem("session"));
	}

	onMount(async () => {
		if (!isTouchEnabled) {
			tooltips = false;
		}
		formId = window.location.pathname.substring(window.location.pathname.lastIndexOf("/") + 1);
		if (!formId)
			formId = "b8f0ddb8-5b52-4452-9ffd-def7fad89f05";
		let params = (new URL(document.location)).searchParams;
		if (params.get("public") !== null)
			isPublic = true;
		if (isPublic) {
			let [res, err] = await fetchData("/v1/session/form/" + formId);
			if (err) {
				modal = {
					view: "forbidden"
				};
				return;
			}
			if (res.data) {
				session = res.data;
				getForm();
			}
			else {
				modal = {
					view: "passphrase"
				};
			}
		}
		else if (session.token) {
			getForm();
			let [res, err] = await fetchData("/v1/session", {
				headers: {
					"Authorization": "Bearer " + session.token,
					"x-message-token": messageToken
				}
			});
			if (err == "invalid or expired jwt") {
				emailAuth()
			}
			else if (!err) {
				session = res.data;
				localStorage.setItem("session", JSON.stringify(session));
			}
		}
		else {
			emailAuth()
		}
  });
	async function emailAuth() {
		let [res, err] = await fetchData("/v1/session/email");
		if (!err) {
			session = res.data;
			localStorage.setItem("session", JSON.stringify(session));
			getForm();
		}
		else {
			modal = {
				view: "login"
			};
		}
	}
	async function messageHandler(message) {
		if (message.detail.type == "content") {
			content = message.detail.data;
			keys.content = generateID();
		}
		else if (message.detail.type == "submit") {
			submit = true;
		}
		else if (message.detail.type == "modal") {
			modal = message.detail.data;
		}
		else if (message.detail.type == "session") {
			session = message.detail.data;
			if (!session.token) {
				localStorage.removeItem("session");
				await fetchData("/v1/session/end", {
					headers: {
						"Authorization": "Bearer " + session.token,
						"x-message-token": messageToken
					}
				});
				window.location = "/";
			}
			else {
				localStorage.setItem("session", JSON.stringify(session));
				getForm();
			}
		}
		else if (message.detail.type == "toast") {
			toast = message.detail.data;
			keys.toast = generateID();
			setTimeout(() => toast = null, 5000);
		}
	}
	async function getForm() {
		form = "";
		let [res, err] = await fetchData("/v1/forms/" + formId, {
			headers: {
				"Authorization": "Bearer " + session.token
			}
		});
		if (err) {
			modal = {
				view: "forbidden"
			};
			return;
		}
		form = res.data;
		form.id = formId;
		modal = {
			view: "form",
			form: form,
			layer: "",
      map: "",
		};
	}
	function closeToast() {
		toast = null;
	}
</script>

<div class="app off-canvas" style="background-color:#a9d9bb;">
	{#if modal}
		<svelte:component tooltips={tooltips} isPublic={isPublic} this={modalViews[modal.view]} modal={modal} session={session} messageToken={messageToken} on:message={messageHandler} />
	{/if}
	
	{#if toast}
		<Identity key={keys.toast}>
			<div id="toast" class="toast" on:click={closeToast}  transition:fly="{{ y: 100, duration: 500 }}">
				<button type="button" class="btn btn-clear float-right"></button>
				{toast.message}
			</div>
		</Identity>
	{/if}
	<div class="off-canvas-content">
		<div class="panel">
  <div class="panel-header">
    <div class="panel-title">Public Form</div>
  </div>
  <div class="panel-body">
		{#if submit}
			<h2>This form has been submitted.</h2>
		{:else}
    	<h2>This form has been closed.</h2>
		{/if}
  </div>
  <div class="panel-footer">
    <a class="btn btn-primary" href="/">Home</a>
		<button class="btn btn-primary" on:click={function () {
			modal = {
				view: "form",
				form: form,
				layer: "",
				map: "",
			};
		}}>Reopen</button>
  </div>
</div>
		{#if content}
			<Identity key={keys.content}>
				<svelte:component tooltips={tooltips} this={contentViews[content.view]} form={form} keys={keys} content={content} session={session} on:message={messageHandler} />
			</Identity>
		{/if}
	</div>
</div>

<style>
	.panel {
		width: 400px;
		height: 400px;
		background: white;
		margin: auto;
		margin-top: 60px;
		border-radius: 20px;
	}
	.panel-header {
		background: #00ab5f;
		color: #ffffff;
		border-top-left-radius: 20px;
		border-top-right-radius: 20px;
	}
	.panel-body {
		text-align: center;
		margin-top: 40px;
	}
	.btn {
		width: 100%;
		margin-bottom: 10px;
	}
	.app {
		min-height: 100vh;
		overflow: hidden;
	}
	#toast {
		position: fixed;
		right: 1rem;
		bottom: 1rem;
		width: 300px;
		z-index: 100;
	}
	.off-canvas .off-canvas-content {
		padding: 0;
	}
</style>